import { memo } from 'react';

import ExitToAppIcon from 'mdi-react/ExitToAppIcon';
import { authService } from 'services';

import { Container } from './styles';

const LogoutAccount = () => {
  return (
    <Container onClick={authService.logout}>
      <ExitToAppIcon />
      <span>Sair</span>
    </Container>
  );
};

export default memo(LogoutAccount);
